export default __webpack_public_path__ + "img/MYMY-circular-logo.c9df30576388f03c253fde497e795459.svg";